import ArchivioModelliView from "./ArchivioModelliView";
import {useContext, useEffect, useState} from "react";
import {MobileContext} from "../../context/MobileContext";
import TreeContainer from "../../components/tree/TreeContainer";
import {FiltersContext} from "../../context/FiltersContext";
import {LoaderContext} from "../../context/LoaderContext";
import {RuoliContext} from "../../context/RuoliContext";
import {useHistory, useParams} from "react-router-dom";
import {BreadcrumbsContext} from "../../context/BreadcrumbsContext";
import {
    deleteTitoloApi,
    getMarcaArchivioByIdApi,
    getTitoliApi,
    getTemiApi,
    eliminaMarcaArchivioApi
} from "../../services/ArchivioServices";

export default function ArchivioModelliController() {
    const {idMarca} = useParams();

    const [marca, setMarca] = useState(null);
    const [titoli, setTitoli] = useState([]);
    const [temi, setTemi] = useState([]);
    const [titoloSel, setTitoloSel] = useState();
    const [keyTab, setKeyTab] = useState();
    const [keyTabSottotemi, setKeyTabSottotemi] = useState();
    const [titoloToDelete, setTitoloToDelete] = useState();
    const [idTitoloUpdate, setIdTitoloUpdate] = useState();
    const [showConfirmDelTitolo, setShowConfirmDelTitolo] = useState(false);
    const [showModalUpdateTitolo, setShowModalUpdateTitolo] = useState(false);
    const [showConfirmDelMarca, setShowConfirmDelMarca] = useState(false);
    const [showModalUpdateMarca, setShowModalUpdateMarca] = useState(false);
    const [showModalFiltri, setShowModalFiltri] = useState(false);

    const {isMobile} = useContext(MobileContext);
    const {
        filtroArchivio,
        filtroNavArchivio,
        updateFiltroNavArchivio,
        initFiltroNavArchivio,
        getNumFiltroArchivio
    } = useContext(FiltersContext);
    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {
        isRuoloSocio,
        isRuoloClub,
        isRuoloAgenzia,
    } = useContext(RuoliContext);
    const {addElementoBreadcrumbs} = useContext(BreadcrumbsContext);

    const history = useHistory();

    async function getTitoli() {
        const filtri = getStrFiltroTitoli();

        startChiamata();
        const response = await getTitoliApi(filtri);
        endChiamata();

        let titoliResp = response.data.data;
        setTitoli(titoliResp);

        if (filtroNavArchivio['id_archivio_titolo'] && filtroNavArchivio['id_archivio_titolo'] !== '') {
            getTemi(filtroNavArchivio['id_archivio_titolo']);

            if (titoliResp) {
                let arrTitoloSel = titoliResp.filter(st => st.id_archivio_titolo == filtroNavArchivio['id_archivio_titolo']);
                if (arrTitoloSel.length > 0) {
                    setTitoloSel(arrTitoloSel[0]);
                }
            }
        }
    }

    function getStrFiltroTitoli() {
        let f = {
            id_archivio_marca: idMarca
        };

        if (filtroArchivio['marca'] && filtroArchivio['marca'] !== '') {
            f.marca = filtroArchivio['marca'];
        }
        if (filtroArchivio['modello'] && filtroArchivio['modello'] !== '') {
            f.modello = filtroArchivio['modello'];
        }
        if (filtroArchivio['inizioProd'] && filtroArchivio['inizioProd'] !== '') {
            f.inizioProd = filtroArchivio['inizioProd'];
        }
        if (filtroArchivio['fineProd'] && filtroArchivio['fineProd'] !== '') {
            f.fineProd = filtroArchivio['fineProd'];
        }
        if (filtroArchivio['tipo_veicolo'] && filtroArchivio['tipo_veicolo'] !== '') {
            f.tipo_veicolo = filtroArchivio['tipo_veicolo'];
        }
        return f;
    }

    async function getTemi(idTitolo) {
        startChiamata();
        const response = await getTemiApi(idTitolo);
        endChiamata();

        setTemi(response.data.data);
    }

    async function getMarca() {
        startChiamata();
        const response = await getMarcaArchivioByIdApi(idMarca);
        endChiamata();

        setMarca(response.data.data);
    }

    async function eliminaTitolo() {
        const filtri = getStrFiltroTitoli();

        if (titoloToDelete) {
            startChiamata();
            const response = await deleteTitoloApi(titoloToDelete.id_archivio_titolo, filtri);
            endChiamata();

            if (response.data.result == '0') {
                setTitoli(response.data.data);
                clearFiltroPagina();
            } else {
                // TODO errore
            }
        }
    }

    async function eliminaMarca() {
        startChiamata();
        const response = await eliminaMarcaArchivioApi(idMarca);
        endChiamata();

        if (response.data.result == '0') {
            clearFiltroPagina();
            history.goBack();
        } else {
            // TODO errore
        }
    }

    useEffect(() => {
        getTitoli();

        if (filtroNavArchivio['codice_tema'] && filtroNavArchivio['codice_tema'] !== '') {
            setKeyTab(filtroNavArchivio['codice_tema']);
        }
        if (filtroNavArchivio['codice_sottotema'] && filtroNavArchivio['codice_sottotema'] !== '') {
            setKeyTabSottotemi(filtroNavArchivio['codice_sottotema']);
        }
        if (idMarca && idMarca !== '') {
            getMarca();
        }
    }, [filtroArchivio, idMarca]);

    function selectTitolo(elemento) {
        addElementoBreadcrumbs('modello', elemento.modello, undefined, 'marca');
        updateFiltroNavArchivio('id_archivio_titolo', elemento.id_archivio_titolo);
        setTitoloSel(elemento);
        getTemi(elemento.id_archivio_titolo);
    }

    function clearFiltroPagina() {
        initFiltroNavArchivio();
        setTitoloSel();
        setKeyTab();
    }

    const vociClickDestro = [
        {
            title: "Modifica",
            icon: "fas fa-pen",
            fun: (el) => {
                setIdTitoloUpdate(el.id_archivio_titolo);
                setShowModalUpdateTitolo(true);
            }
        },
        {
            title: "Elimina",
            icon: "fas fa-trash",
            fun: (el) => {
                setTitoloToDelete(el);
                setShowConfirmDelTitolo(true);
            }
        },
    ];

    function getAlberoStruttura() {
        return (
            <div className={'ns-overflow-auto ns-overflow-tree'}>
                <TreeContainer
                    data={titoli}
                    idSelected={''}
                    onClickItem={(elemento) => {
                        selectTitolo(elemento);
                    }}
                    getLabel={(elemento) => elemento.modello}
                    getFigli={(elemento) => []}
                    icona={(elemento) => {
                    }}
                    getLabelRightClickMenu={(elemento) => elemento.modello}
                    vociClickDestro={!isRuoloSocio() && !isRuoloClub() && !isRuoloAgenzia() ? vociClickDestro : []}
                />
            </div>
        );
    }

    function handlerModificaTitolo() {
        if (titoloSel) {
            setIdTitoloUpdate(titoloSel.id_archivio_titolo);
            setShowModalUpdateTitolo(true);
        }
    }

    function handlerEliminaTitolo() {
        if (titoloSel) {
            setTitoloToDelete(titoloSel);
            setShowConfirmDelTitolo(true);
        }
    }

    function handlerModificaMarca() {
        setShowModalUpdateMarca(true);
    }

    function handlerEliminaMarca() {
        setShowConfirmDelMarca(true);
    }

    function getTitoloSottotema(tema, sottotema) {
        let titolo = sottotema;

        if (tema.num_documenti_sottotemi) {
            const sottotemiObj = JSON.parse(tema.num_documenti_sottotemi);
            if (sottotemiObj[sottotema]) {
                titolo += ` (${sottotemiObj[sottotema]})`;
            } else {
                titolo += ` (0)`;
            }
        } else {
            titolo += ` (0)`;
        }
        return titolo;
    }

    const handleClickBreadcrumbs = (elementoBrcb) => {
        if (elementoBrcb.name === 'marca' || elementoBrcb.name === 'archivio') {
            clearFiltroPagina();
        }
    }

    return (
        <ArchivioModelliView
            idMarca={idMarca}
            marca={marca}
            isMobile={isMobile}
            getAlberoStruttura={getAlberoStruttura}
            titoli={titoli}
            titoloSel={titoloSel}
            keyTab={keyTab}
            setKeyTab={(key) => {
                updateFiltroNavArchivio('codice_tema', key);
                setKeyTab(key);
            }}
            keyTabSottotemi={keyTabSottotemi}
            setKeyTabSottotemi={(key) => {
                updateFiltroNavArchivio('codice_sottotema', key);
                setKeyTabSottotemi(key);
            }}
            temi={temi}
            handlerRefreshTabs={() => {
                getTemi(titoloSel.id_archivio_titolo);
            }}
            handlerRefreshTitoli={getTitoli}
            selectTitolo={selectTitolo}
            titoloToDelete={titoloToDelete}
            showConfirmDelTitolo={showConfirmDelTitolo}
            showConfirmDelMarca={showConfirmDelMarca}
            setShowConfirmDelTitolo={setShowConfirmDelTitolo}
            setShowConfirmDelMarca={setShowConfirmDelMarca}
            eliminaTitolo={eliminaTitolo}
            eliminaMarca={eliminaMarca}
            idTitoloUpdate={idTitoloUpdate}
            showModalUpdateTitolo={showModalUpdateTitolo}
            showModalUpdateMarca={showModalUpdateMarca}
            handlerModificaTitolo={handlerModificaTitolo}
            handlerEliminaTitolo={handlerEliminaTitolo}
            handlerModificaMarca={handlerModificaMarca}
            handlerEliminaMarca={handlerEliminaMarca}
            closeModalUpdateTitolo={() => {
                setShowModalUpdateTitolo(false);
            }}
            closeModalUpdateMarca={() => {
                setShowModalUpdateMarca(false);
            }}
            updateTitoloOk={(titoloNew) => {
                getTitoli();
                setIdTitoloUpdate(null);
                setTitoloSel(titoloNew);
            }}
            isAdmin={!isRuoloSocio() && !isRuoloClub() && !isRuoloAgenzia()}
            showModalFiltri={showModalFiltri}
            setShowModalFiltri={setShowModalFiltri}
            numFiltroArchivio={getNumFiltroArchivio()}
            getTitoloSottotema={getTitoloSottotema}
            handleClickBreadcrumbs={handleClickBreadcrumbs}
            updateMarcaOk={() => {
                getMarca();
            }}
        />
    );
}